import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card",
  id: "scenario-authoring"
}
const _hoisted_2 = { class: "card-header bg-dark" }
const _hoisted_3 = { class: "text-center text-white my-2" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = {
  key: 0,
  class: "col-12"
}
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "float-end" }
const _hoisted_11 = {
  key: 1,
  class: "col-12"
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "d-flex justify-content-end mt-2" }
const _hoisted_15 = {
  key: 2,
  class: "col-12"
}
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "d-flex justify-content-end mt-2" }
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = {
  key: 3,
  class: "col-12"
}
const _hoisted_21 = { class: "d-flex justify-content-between align-items-center pb-4" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "col-md-12" }
const _hoisted_24 = { class: "list-unstyled pt-2" }
const _hoisted_25 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_26 = { class: "px-4 w-100" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_32 = { class: "px-4 w-100" }
const _hoisted_33 = { class: "list-unstyled" }
const _hoisted_34 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_text_editor = _resolveComponent("text-editor")!
  const _component_create_question = _resolveComponent("create-question")!
  const _component_edit_question = _resolveComponent("edit-question")!
  const _component_modal = _resolveComponent("modal")!
  const _component_VueDraggableNext = _resolveComponent("VueDraggableNext")!
  const _component_dynamic_form = _resolveComponent("dynamic-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && !_ctx.loading_error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.rubric.name), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (!_ctx.rubric.is_published)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.publish && _ctx.publish(...args))),
                      class: "btn btn-primary"
                    }, "Publish Rubric"),
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteRubric && _ctx.deleteRubric(...args))),
                      class: "btn btn-primary ms-2"
                    }, "Delete Rubric"),
                    _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                    _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                    _cache[18] || (_cache[18] = _createElementVNode("hr", null, null, -1)),
                    _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                (!_ctx.rubric.is_published)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.edit_name = !_ctx.edit_name)),
                      class: "btn btn-link text-primary btn-sm"
                    }, _cache[20] || (_cache[20] = [
                      _createElementVNode("i", { class: "fa fa-edit" }, null, -1)
                    ])))
                  : _createCommentVNode("", true),
                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "text-muted" }, "Name: ", -1)),
                _cache[24] || (_cache[24] = _createTextVNode()),
                (!_ctx.edit_name)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.rubric.name), 1))
                  : _createCommentVNode("", true),
                (_ctx.edit_name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.name) = $event)),
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.name]
                      ]),
                      _createElementVNode("span", _hoisted_10, [
                        _createElementVNode("button", {
                          class: "btn btn-primary",
                          type: "button",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveName && _ctx.saveName(...args)))
                        }, _cache[21] || (_cache[21] = [
                          _createElementVNode("span", { class: "d-none d-xl-block" }, "Save", -1),
                          _createElementVNode("i", { class: "fas fa-save d-block d-xl-none" }, null, -1)
                        ])),
                        _createElementVNode("button", {
                          class: "btn btn-secondary",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.edit_name = false)),
                          type: "button"
                        }, _cache[22] || (_cache[22] = [
                          _createElementVNode("span", { class: "d-none d-xl-block" }, "Cancel", -1),
                          _createElementVNode("i", { class: "fas fa-ban d-block d-xl-none" }, null, -1)
                        ]))
                      ]),
                      _createVNode(_component_Loading, {
                        active: _ctx.name_loading,
                        "is-full-page": false
                      }, null, 8, ["active"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.rubric.is_published || (_ctx.rubric.is_published && _ctx.rubric.scorer_instructions !== null))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (!_ctx.rubric.is_published)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.edit_scorer = !_ctx.edit_scorer)),
                          class: "btn btn-link text-primary btn-sm"
                        }, _cache[25] || (_cache[25] = [
                          _createElementVNode("i", { class: "fa fa-edit" }, null, -1)
                        ])))
                      : _createCommentVNode("", true),
                    _cache[26] || (_cache[26] = _createElementVNode("label", { class: "text-muted" }, "Scorer Instructions", -1)),
                    (!_ctx.edit_scorer)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          innerHTML: _ctx.rubric.scorer_instructions,
                          class: "ps-4 pt-2"
                        }, null, 8, _hoisted_12))
                      : _createCommentVNode("", true),
                    (_ctx.edit_scorer)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(_component_text_editor, {
                            modelValue: _ctx.scorer_instructions,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.scorer_instructions) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("button", {
                              class: "btn btn-primary",
                              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.saveScorerInstructions && _ctx.saveScorerInstructions(...args)))
                            }, "Save"),
                            _createElementVNode("button", {
                              class: "btn btn-default mx-2",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.edit_scorer = false))
                            }, "Cancel")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.rubric.is_published || (_ctx.rubric.is_published && _ctx.rubric.learner_instructions !== null))
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (!_ctx.rubric.is_published)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.edit_learner = !_ctx.edit_learner)),
                          class: "btn btn-link text-primary btn-sm"
                        }, _cache[27] || (_cache[27] = [
                          _createElementVNode("i", { class: "fa fa-edit" }, null, -1)
                        ])))
                      : _createCommentVNode("", true),
                    _cache[28] || (_cache[28] = _createElementVNode("label", { class: "text-muted" }, "Learner Instructions", -1)),
                    (!_ctx.edit_learner)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          innerHTML: _ctx.rubric.learner_instructions,
                          class: "ps-4 pt-2"
                        }, null, 8, _hoisted_16))
                      : _createCommentVNode("", true),
                    (_ctx.edit_learner)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_text_editor, {
                            modelValue: _ctx.learner_instructions,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.learner_instructions) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("button", {
                              class: "btn btn-primary",
                              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.saveLearnerInstructions && _ctx.saveLearnerInstructions(...args)))
                            }, "Save"),
                            _createElementVNode("button", {
                              class: "btn btn-default mx-2",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.edit_learner = false))
                            }, "Cancel")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _cache[36] || (_cache[36] = _createElementVNode("div", { class: "col-12" }, [
                _createElementVNode("br"),
                _createElementVNode("hr"),
                _createElementVNode("br")
              ], -1)),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.cloneRubric && _ctx.cloneRubric(...args))),
                  class: "btn btn-primary btn-sm"
                }, "Clone Rubric")
              ]),
              _cache[37] || (_cache[37] = _createElementVNode("div", { class: "col-12" }, [
                _createElementVNode("br"),
                _createElementVNode("hr"),
                _createElementVNode("br")
              ], -1)),
              (!_ctx.rubric.is_published)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_create_question, {
                        form_type: 'rubric',
                        onUpdate: _ctx.newQuestion,
                        rubric: _ctx.rubric
                      }, {
                        trigger: _withCtx((triggerProps) => [
                          _createElementVNode("button", {
                            onClick: triggerProps.click,
                            class: "btn btn-primary"
                          }, _cache[29] || (_cache[29] = [
                            _createElementVNode("i", { class: "fa fa-plus" }, null, -1),
                            _createTextVNode(" Create Question ")
                          ]), 8, _hoisted_22)
                        ]),
                        _: 1
                      }, 8, ["onUpdate", "rubric"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_23, [
                _cache[35] || (_cache[35] = _createElementVNode("h4", { class: "text-secondary" }, "Questions:", -1)),
                _createElementVNode("ul", _hoisted_24, [
                  _createVNode(_component_VueDraggableNext, {
                    modelValue: _ctx.rubric.rubric_questions,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.rubric.rubric_questions) = $event)),
                    onChange: _ctx.reorder,
                    sort: !_ctx.rubric.is_published
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rubric.rubric_questions, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: _normalizeClass(["px-4 py-2 border-bottom", {'border-0':index+1 === _ctx.rubric.questions.length,'bg-lighter':item.rubric}]),
                          key: index
                        }, [
                          (item.question)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _cache[32] || (_cache[32] = _createElementVNode("i", { class: "text-primary fas fa-bars" }, null, -1)),
                                _createElementVNode("div", _hoisted_26, _toDisplayString(item.question.short_description), 1),
                                (_openBlock(), _createBlock(_component_edit_question, {
                                  rubric: _ctx.rubric,
                                  question: item.question,
                                  onUpdateQuestionData: _ctx.getRubric,
                                  key: item.question.id,
                                  form_type: 'rubric'
                                }, {
                                  trigger: _withCtx((triggerProps) => [
                                    (!_ctx.rubric.is_published)
                                      ? (_openBlock(), _createElementBlock("i", {
                                          key: 0,
                                          onClick: triggerProps.click,
                                          class: "cursor-pointer text-primary fa fa-edit"
                                        }, null, 8, _hoisted_27))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["rubric", "question", "onUpdateQuestionData"])),
                                _cache[33] || (_cache[33] = _createTextVNode("   ")),
                                (!_ctx.rubric.is_published)
                                  ? (_openBlock(), _createElementBlock("i", {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.showDeleteQuestionModal(item.id)),
                                      class: "cursor-pointer text-primary fa fa-trash"
                                    }, null, 8, _hoisted_28))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_modal, {
                                  modelValue: _ctx.delete_question[item.id],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.delete_question[item.id]) = $event)
                                }, {
                                  header: _withCtx(() => _cache[30] || (_cache[30] = [
                                    _createTextVNode("Permanently Delete Question")
                                  ])),
                                  default: _withCtx(() => [
                                    _cache[31] || (_cache[31] = _createElementVNode("p", null, "Are you sure you want to delete this Question?", -1)),
                                    _createElementVNode("button", {
                                      class: "btn btn-xs btn-secondary-alt float-end",
                                      onClick: ($event: any) => (_ctx.showDeleteQuestionModal(item.id))
                                    }, "Cancel", 8, _hoisted_29),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-primary btn-xs",
                                      onClick: ($event: any) => (_ctx.removeQuestion(item.id,index))
                                    }, "Permanently Delete", 8, _hoisted_30)
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                              ]))
                            : _createCommentVNode("", true),
                          (item.rubric)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _cache[34] || (_cache[34] = _createElementVNode("i", { class: "text-primary fas fa-bars" }, null, -1)),
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("strong", null, "Rubric: " + _toDisplayString(item.rubric.name), 1),
                                  _createElementVNode("ul", _hoisted_33, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.rubric.rubric_questions, (rubricItem, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        class: _normalizeClass(["py-2 border-bottom", {'border-0':index+1 === item.rubric.rubric_questions.length}]),
                                        key: index
                                      }, _toDisplayString(rubricItem.short_description), 3))
                                    }), 128))
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange", "sort"])
                ]),
                _createVNode(_component_dynamic_form, {
                  class: "mt-4",
                  label: "Rubric Preview",
                  questions: _ctx.formatted_questions
                }, null, 8, ["questions"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.loading_error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _cache[38] || (_cache[38] = _createElementVNode("h3", null, "Error Loading Rubric", -1)),
          _createElementVNode("p", null, _toDisplayString(_ctx.loading_error_str), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}